import useDeviceOrientation from "../useDeviceOrientation";
import { useEffect } from "react";
import { useAppSelector } from "../../store/index.ts";
import useFullScreen from "./useFullScreen";

export default function useDetectFS() {
  const { isMobileHorizontal } = useDeviceOrientation();
  const isFullScreen = useAppSelector((state) => state.common.flags.foolScreen);
  const { makeFullScreen } = useFullScreen();

  useEffect(() => {
    if (!isMobileHorizontal) return;
    if (isFullScreen) return;
    makeFullScreen();
  }, [isMobileHorizontal]);
}
